var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.5V32.5M30 40V40.025M7.5 30C7.5 32.9547 8.08198 35.8806 9.21271 38.6104C10.3434 41.3402 12.0008 43.8206 14.0901 45.9099C16.1794 47.9992 18.6598 49.6566 21.3896 50.7873C24.1194 51.918 27.0453 52.5 30 52.5C32.9547 52.5 35.8806 51.918 38.6104 50.7873C41.3402 49.6566 43.8206 47.9992 45.9099 45.9099C47.9992 43.8206 49.6566 41.3402 50.7873 38.6104C51.918 35.8806 52.5 32.9547 52.5 30C52.5 27.0453 51.918 24.1194 50.7873 21.3896C49.6566 18.6598 47.9992 16.1794 45.9099 14.0901C43.8206 12.0008 41.3402 10.3434 38.6104 9.21271C35.8806 8.08198 32.9547 7.5 30 7.5C27.0453 7.5 24.1194 8.08198 21.3896 9.21271C18.6598 10.3434 16.1794 12.0008 14.0901 14.0901C12.0008 16.1794 10.3434 18.6598 9.21271 21.3896C8.08198 24.1194 7.5 27.0453 7.5 30Z",
    stroke: "#F74055",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.61e8797fe75ff1e68be8158e409ab311.svg";
export { ForwardRef as ReactComponent };